var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3034_13376)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1059 22.7142C14.0487 22.7142 12.1385 21.9061 10.7426 20.5101C10.4487 20.2163 10.4487 19.7754 10.7426 19.4816C11.0365 19.1877 11.4773 19.1877 11.7712 19.4816C12.9467 20.6571 14.4895 21.2448 16.1059 21.2448C19.5589 21.2448 22.3508 18.453 22.3508 14.9999C22.3508 11.5469 19.5589 8.75503 16.1059 8.75503C13.2406 8.75503 10.7426 10.6652 10.0814 13.4571C9.93444 13.9714 9.86097 14.4856 9.86097 14.9999C9.86097 15.3673 9.86097 15.7346 9.93444 16.102L11.5508 14.4856C11.8446 14.1918 12.2855 14.1918 12.5793 14.4856C12.8732 14.7795 12.8732 15.2203 12.5793 15.5142L10.0814 18.0122L10.0079 18.0856C9.71403 18.3795 9.27321 18.3795 8.97934 18.0856L6.40791 15.5142C6.11403 15.2203 6.11403 14.7795 6.40791 14.4856C6.70179 14.1918 7.1426 14.1918 7.43648 14.4856L8.39158 15.4407C8.39158 15.2938 8.39158 15.1469 8.39158 14.9999C8.39158 14.3387 8.46505 13.6775 8.61199 13.0897C9.49362 9.71013 12.5793 7.28564 16.1059 7.28564C20.3671 7.28564 23.8202 10.7387 23.8202 14.9999C23.8202 19.2612 20.3671 22.7142 16.1059 22.7142ZM18.6773 18.6734C18.4569 18.6734 18.3099 18.5999 18.163 18.453L15.2242 15.5142C15.0773 15.3673 15.0038 15.2203 15.0038 14.9999V11.3265C15.0038 10.8856 15.2977 10.5918 15.7385 10.5918C16.1793 10.5918 16.4732 10.8856 16.4732 11.3265V14.7061L19.1916 17.4244C19.6324 17.8652 19.3385 18.6734 18.6773 18.6734Z",
    fill: "#403C6F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 3.5,
    stroke: "#E9E9E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3034_13376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTable);
export default __webpack_public_path__ + "static/media/viewTable.7fd00795fbadde76a3192d8ac084bded.svg";
export { ForwardRef as ReactComponent };